export enum ShoppingCartEnum {
    MAX_ITEMS_IN_SHOPPING_CART = 50
}
